import { useEffect, useState, type RefObject } from 'react';

/** The room around the cover in the stage area, in CSS pixels (the size line sits under the cover). */
const STAGE_PADDING = 56;
const MIN_SIDE = 160;

/** The side of the largest square that fits the stage area, watched with a `ResizeObserver`. */
export function useStageSize(area: RefObject<HTMLElement | null>): number {
  const [side, setSide] = useState(MIN_SIDE);
  useEffect(() => {
    const element = area.current;
    if (element === null) {
      return undefined;
    }
    const measure = () => {
      const fit = Math.min(element.clientWidth, element.clientHeight) - STAGE_PADDING * 2;
      setSide(Math.max(MIN_SIDE, Math.floor(fit)));
    };
    measure();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', measure);
      return () => window.removeEventListener('resize', measure);
    }
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [area]);
  return side;
}
